var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar_right_arrow",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    viewBox: "0 0 29 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3",
    "data-name": "Ret\\xE2ngulo 3",
    width: 27.841,
    height: 26.406,
    transform: "translate(0 0)",
    fill: "#35bde8",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_90",
    "data-name": "Caminho 90",
    d: "M223.073,1019.2h4.651v-1.834a.358.358,0,1,1,.716,0v1.834h3.936v-1.834a.358.358,0,1,1,.716,0v1.834h3.936v-1.834a.358.358,0,1,1,.716,0v1.834h4.651a1.088,1.088,0,0,1,1.073,1.1v15.4a1.088,1.088,0,0,1-1.073,1.1h-19.32a1.088,1.088,0,0,1-1.073-1.1v-15.4A1.088,1.088,0,0,1,223.073,1019.2Zm19.32.734h-19.32a.362.362,0,0,0-.358.367v3.4l20.035-.189V1020.3A.362.362,0,0,0,242.393,1019.934Zm-19.32,16.137h19.32a.362.362,0,0,0,.358-.367V1024.24l-20.035.189V1035.7A.362.362,0,0,0,223.073,1036.071Z",
    transform: "translate(-218.813 -1013.699)",
    fill: "#35bde8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_91",
    "data-name": "Caminho 91",
    d: "M10.171,3.3h0s0,.006,0,.01a.392.392,0,0,1-.03.134.407.407,0,0,1-.086.126L6.961,6.664a.367.367,0,1,1-.519-.519L8.875,3.712.367,3.939A.354.354,0,0,1,0,3.572a.4.4,0,0,1,.387-.387L8.9,2.958,6.587.65A.377.377,0,0,1,6.6.118.4.4,0,0,1,6.871,0a.356.356,0,0,1,.263.1l2.934,2.934a.257.257,0,0,1,.014.022.351.351,0,0,1,.064.1A.367.367,0,0,1,10.171,3.3Z",
    transform: "translate(15.11 22.529) rotate(-135)",
    fill: "#35bde8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBack);
export default __webpack_public_path__ + "static/media/calendar-back.b98187db04f6c328504ceb47305a43c6.svg";
export { ForwardRef as ReactComponent };